<template>
  <div class="wrap project-item" :class="{ 'view-table-row': view === 'table-row' }" v-b-tooltip.hover.html="{ variant: 'base' }" :title="getProjectTooltip || ''">
    <a :href="`https://giraffesoftware.atlassian.net/browse/${link}`" target="_blank" class="project-link">
      <div class="project-title">
        <span v-if="number || number === 0">{{ number + 1 }}.</span> {{ projectName }}
      </div>
      <div class="project-subtitle" v-if="projectSubtitle !== ''">
        {{ projectSubtitle }}
      </div>
      <div class="project-owner">
        {{ projectClients }}
      </div>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    link: {
      type: String,
      default: ''
    },
    number: {
      type: Number,
      default: 1
    },
    projectName: {
      type: String,
      default: ''
    },
    projectSubtitle: {
      type: String,
      default: ''
    },
    projectClients: {
      type: String,
      default: ''
    },
    view: {
      type: String,
      default: 'default'
    }
  },
  computed: {
    getProjectTooltip () {
      return `<div class="text-left">${this.projectName || ''} <br/> ${this.projectSubtitle || ''}</div>` || ''
    }
  }
}
</script>

<style lang="scss">
  .project {
    &-link {
      &:hover {
        text-decoration: none;
      }
    }
    &-title {
      font-size: 13px;
      color: #3D5170;
      max-width: 150px;
      margin-bottom: 2px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    &-subtitle {
      font-size: 11px;
      color: #7489A9;
      max-width: 350px;
      margin-bottom: 2px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    &-owner {
      font-size: 11px;
      color: #7489A9;
      max-width: 150px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
  .view-table-row {
    display: flex;
    align-items: center;
    .project-owner {
      display:none;
    }
  }
</style>
